(function () {
  var brandListSlide = () => {
    var $slickElement = $('.icon-columns__slider').not('.slick-initialized');

    $slickElement.slick({
      slidesToShow: 3,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1330,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  }

  document.addEventListener('shopify:section:load', function () {
    brandListSlide();
  });

  brandListSlide();

})();